import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Building2, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BusinessRegister() {
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", billing_email: "", address: "", tax_id: "", notes: "" });
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.name.trim().length < 2) return toast.error("Company name is required");
    try {
      setSaving(true);
      await axios.post(`${API}/business/register`, form);
      toast.success("Business account created — invite your team next");
      nav("/business/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Registration failed");
    } finally { setSaving(false); }
  };

  return (
    <div className="mx-auto max-w-2xl px-6 py-10" data-testid="business-register">
      <div className="mb-6">
        <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-copper">
          <Building2 className="h-4 w-4" /> EasyStay Business
        </div>
        <h1 className="mt-2 font-display text-3xl font-bold text-slate-900 sm:text-4xl">Register your company</h1>
        <p className="mt-2 text-slate-600">
          Book staff accommodation without your employees paying personally. EasyStay invoices the company after each stay.
        </p>
      </div>
      <form onSubmit={submit} className="space-y-3 rounded-3xl border border-slate-200 bg-white p-6 card-shadow">
        <Field label="Company name" required>
          <input data-testid="biz-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
            placeholder="Acme Zambia Ltd" className="input" required />
        </Field>
        <Field label="Billing email" required>
          <input data-testid="biz-email" type="email" value={form.billing_email}
            onChange={(e) => setForm({ ...form, billing_email: e.target.value })}
            placeholder="finance@acme.co.zm" className="input" required />
        </Field>
        <Field label="Address">
          <input data-testid="biz-address" value={form.address}
            onChange={(e) => setForm({ ...form, address: e.target.value })}
            placeholder="Plot 123, Cairo Rd, Lusaka" className="input" />
        </Field>
        <Field label="Tax / TPIN">
          <input data-testid="biz-tax" value={form.tax_id}
            onChange={(e) => setForm({ ...form, tax_id: e.target.value })}
            placeholder="TPIN or business registration number" className="input" />
        </Field>
        <Field label="Notes (internal)">
          <textarea data-testid="biz-notes" value={form.notes}
            onChange={(e) => setForm({ ...form, notes: e.target.value })}
            rows={3} className="input" placeholder="How your team travels, cost centres, anything useful for the finance handoff…" />
        </Field>
        <button data-testid="biz-submit" type="submit" disabled={saving} className="btn-primary w-full text-sm disabled:opacity-50">
          {saving ? <Loader2 className="mx-auto h-4 w-4 animate-spin" /> : "Create Business account"}
        </button>
      </form>
    </div>
  );
}

function Field({ label, required, children }) {
  return (
    <label className="block">
      <div className="text-xs uppercase tracking-widest text-slate-500">
        {label}{required && <span className="ml-1 text-copper">*</span>}
      </div>
      <div className="mt-1">{children}</div>
      <style>{`.input { width: 100%; border-radius: 0.75rem; border: 1px solid #e2e8f0; background: #f8fafc; padding: 0.75rem 1rem; font-size: 0.875rem; outline: none; }
        .input:focus { border-color: #C85A17; background: #fff; }`}</style>
    </label>
  );
}
